import PrecatoriosAltoValor from './AltoValor/PrecatoriosAltoValor';

export default PrecatoriosAltoValor;